// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__13Urg","author":"Table_author__jTZ0b","authorImage":"Table_authorImage__3P8p_","unreadRow":"Table_unreadRow__i7j8P"};